import { useQuery } from '@apollo/client';
import type * as React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GET_USER_QUERY } from '../../../graphql/resolvers/userQueries/getUser.gql';
import type { UserState } from '../../../interfaces/user.interface';
import { userSlice } from '../../../store/user.store';
import './user-username-layout.scss';

interface DashboardProps {
  children?: React.ReactNode;
}

export default function UserDashboard(
  props: DashboardProps,
): React.ReactElement {
  const { children } = props;

  const dispatch = useDispatch();
  const { user, updateUserInit } = useSelector(
    (state: UserState) => state.userStore,
  );

  const { UPDATE_USER_SUCCESS } = userSlice.actions;
  const { refetch } = useQuery(GET_USER_QUERY, {
    variables: {
      userId: user?.id as string,
    },
    skip: !user?.id,
  });

  useEffect(() => {
    if (updateUserInit) {
      refetch().then((res) => {
        const updatedUser = res.data?.getUser;
        if (updatedUser) {
          dispatch(UPDATE_USER_SUCCESS(updatedUser));
        }
      });
    }
  }, [dispatch, UPDATE_USER_SUCCESS, refetch, updateUserInit]);

  return (
    <div className="APP__User__Layout">
      <section className="APP__User__Layout__SECTION" id="User__Layout">
        {children}
      </section>
    </div>
  );
}
